export default __webpack_public_path__ + "images/Four_Chamber_View_of_the_Heart.fc375d5553f816f12e4a854378ff7ad4.png";